<mat-form-field appearance="outline" [color]="isWarning ? 'warn' : isDisabled ? 'locked' : null" class="mat-input-search-wrapper">
  <i matPrefix class="search-icon" [nimbusIcon]="icons.SEARCH_LIGHT"></i>
  <div matPrefix>
    <ng-container *ngTemplateOutlet="prefixTemplateRef"></ng-container>
  </div>
  <input
    matInput
    [placeholder]="placeholder || TranslationKeys.GeneralTypeInToSearch | translate"
    [attr.aria-label]="placeholder || TranslationKeys.GeneralTypeInToSearch | translate"
    [attr.maxlength]="maxLength"
    [(ngModel)]="value"
    #inputElement
    [disabled]="isDisabled"
    (keydown)="onKeyDown($event)"
    [errorStateMatcher]="this"
    spellcheck="false"
    autocomplete="off"
  />
  @if (isDisabled) {
    <i class="close-icon cursor-pointer" matSuffix [nimbusIcon]="icons.LOCK"></i>
  }
  @if (!isDisabled && value) {
    <i
      matSuffix
      class="cursor-pointer"
      tabindex="0"
      role="button"
      [attr.aria-label]="TranslationKeys.AriaLabelInputClear | translate"
      [nimbusIcon]="icons.CLOSE_LIGHT"
      (click)="onClearValueClick($event)"
      (keydown.enter)="$event.preventDefault(); onClearValueClick($event)"
    ></i>
  }
  <div matPrefix>
    <ng-content></ng-content>
  </div>
  <div matSuffix>
    <ng-container *ngTemplateOutlet="suffixTemplateRef"></ng-container>
  </div>
  @if (isErrorState(null, null)) {
    <mat-error>
      <i [nimbusIcon]="icons.EXCLAMATION_TRIANGLE" class="error-triangle"></i>
      <div>{{ inputValidator.getErrorMessage(ngControl.errors) }}</div>
    </mat-error>
  }
</mat-form-field>
